<template>
	<Modal @close="$emit('close')" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>Edit {{ person.name }}</h3>
				</div>
			</div>
			<Form :person="person" @close="$emit('close')"/>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import Form from './Form.vue'

export default {
	components: {
		Modal,
		Form
	},
	props: [
		'person'
	]
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/People/Edit.vue